import Http from "../../http/client";

export default async (payload) => {
  const response = await Http.post('admin/driver/company', payload);
  return response.data;
}
